var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipLoaderLocked10M3Ldt10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    viewBox: "197 143 501 343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Skip_Loader_Locked_10m3_LDT10_svg__st0{fill:currentColor}.Skip_Loader_Locked_10m3_LDT10_svg__st12{fill:#fff;enable-background:new}.Skip_Loader_Locked_10m3_LDT10_svg__st19,.Skip_Loader_Locked_10m3_LDT10_svg__st21{enable-background:new}.Skip_Loader_Locked_10m3_LDT10_svg__st8{opacity:.1;fill:#fff;enable-background:new}.Skip_Loader_Locked_10m3_LDT10_svg__st12,.Skip_Loader_Locked_10m3_LDT10_svg__st19{opacity:.2}.Skip_Loader_Locked_10m3_LDT10_svg__st19,.Skip_Loader_Locked_10m3_LDT10_svg__st21{fill:#030405}.Skip_Loader_Locked_10m3_LDT10_svg__st21{opacity:.1}.Skip_Loader_Locked_10m3_LDT10_svg__st22,.Skip_Loader_Locked_10m3_LDT10_svg__st23,.Skip_Loader_Locked_10m3_LDT10_svg__st24,.Skip_Loader_Locked_10m3_LDT10_svg__st25{enable-background:new}.Skip_Loader_Locked_10m3_LDT10_svg__st23{opacity:.3;fill:#fff}.Skip_Loader_Locked_10m3_LDT10_svg__st24{opacity:.2}.Skip_Loader_Locked_10m3_LDT10_svg__st25{opacity:.1}.Skip_Loader_Locked_10m3_LDT10_svg__st26{opacity:.2}.Skip_Loader_Locked_10m3_LDT10_svg__st27{opacity:.1}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: "100%",
    height: "100%",
    viewBox: "0 0 386 344"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 386,
    height: 344,
    href: ""
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    width: "100%",
    height: "100%",
    viewBox: "0 0 153 170"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 153,
    height: 170,
    href: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Container_4_00000049938511882527851810000007751059276589140868_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Bakgrund_\\xC4ndra_F\\xE4rg_00000164477136049537723460000017870898787559403706_",
    d: "m345.1 143.8-.3-.1-5.2-.6-121.2 11.4v5.1L198 266.8v109.8l5 1.5 4.7-1 2.4 3-2.2 5.3.5.7-.6.1c-1.1.2-2 1.5-2 3.2-.1 1.9.9 3.7 2.7 4.5.3.1.6.1.8 0l1.9-.4c.2-.1.5-.2.7-.3l-1.4 3.5 17.6 5.6 1.2 1.5 3.4 1v6.2l9 2.9 11.1-2.7 23.5 7.5v2.7l7.3 2.3 4.7-1.2 46.1 14.7v6.7l10.5 3.4 11.2-3.2 52.7 16.8v3l8.7 2.9 4.8-1.5 30.4 9.7v7.3l12.4 4 140.5-46.9v-6.6l72.2-104.5 19.6-5 .3-8.3-4.1-4.9-3.8-2.3 2.5-126.6-347.2-37.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlights_20_x25__00000065076404823467237120000001374540940626367141_",
    d: "m227.8 154.8 111.8-11.6 352.8 38.1-115.2 17.4-349.4-43.9z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_20_x25__00000126290534889702638240000001950192046603106176_",
    d: "m559 349.5 138.8-34.4-.3 8.3-19.6 5-72.2 104.5v6.6l-140.5 46.9v-7.2l.7.4 80.5-124.1 6.8 4.5 5.8-10.5z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_10_x25__00000178192496902838336400000007036877450163172997_",
    d: "M577.3 198.7v6.4l115.2-17.9v-5.9l-115.2 17.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Skip_Loader_Locked_10m3_LDT10_LogoB",
    transform: "translate(192.4,139.8)",
    d: "m391.84 76.816h82.945v81.31h-82.945z",
    fill: "url(#pattern-2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Skip_Loader_Locked_10m3_LDT10_LogoA",
    transform: "translate(192.4,139.8)",
    d: "m37.182 177.74h215.33v125.03h-215.33z",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlights_10_x25_",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st22",
    transform: "translate(0 6.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25285",
    d: "m422.5 309.3-4.8-1-2-.4-6.8-1.5-120.5-26.3-4.7-1-80.6-17.6 20.4-107.6v-5.1l-5-.6v5.1l-20.4 107.2v109.8l5 1.5v-99.4l4.7 1.1 68.6 15.5v12.4l.6-.1c.3-.1.6-.1.9 0 1 .3 1.9 1.1 2.3 2.1h.6c.7.3 1.2 1.1 1.1 1.8.1.5-.2 1.1-.7 1.3l-.2.1c.1 1.4-.7 2.8-2.1 3.3l-2.1.5h-.1l-.2.1v104.7l7.3 2.3V290.7l4.7 1.1L408.8 319l.2 13.6.4-.1c.4-.1.8-.1 1.1 0 1.2.4 2.1 1.2 2.6 2.4h.6c.8.4 1.3 1.2 1.2 2.1 0 .8-.4 1.3-.8 1.5l-.2.1c-.1 2-1 3.4-2.4 3.7l-2.3.5h-.3v115.1l8.8 2.8.1-139.5 4.7 1.1 124 27 6.8 4.5L559 343l-5.2-4.3-131.3-29.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25286",
    d: "M411.5 338.6c0-2.7-1.5-5.2-3.4-5.6-.3-.1-.6-.1-.9 0-1.4.2-2.4 1.8-2.4 4 0 2.6 1.5 5.2 3.3 5.6.3.1.6.1.8 0h.2c1.6-.7 2.6-2.3 2.4-4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25287",
    d: "M278.8 306.7c.2-2.1-1-4.1-3-5-.3-.1-.5-.1-.8 0-1.3.2-2.2 1.6-2.2 3.6-.2 2.1 1.1 4.1 3 5 .2.1.4.1.7.1l.2-.1c1.2-.3 2.1-1.6 2.1-3.6z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlight_30_x25__00000144331383157809198940000010187833956461345157_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25304",
    d: "m389 188.4 165.8 23.4 8-1.2-165.9-23.1-7.9.9z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25305",
    d: "m373.1 186.5 7.1-1.1-147-20.5-6 .7-1 .1 146.9 20.8z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25321",
    d: "m231.5 172.4 1.6-.2 142.2 20.3-1.6.6-142.2-20.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25339",
    d: "m392 196.4 1.8-.2 160.4 22.9-1.8.6L392 196.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlights_30_x25__00000060012518368708127150000000061459485355885758_",
    d: "m283.7 285.5 4.7 1 120.5 26.3 5.2 1.1 3.6.8 4.8 1 131.4 29.4-.2-3.1L208 267.1l-4.7.7 80.4 17.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlight_10_x25__00000019676138918416487210000008051686644010866321_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25302",
    d: "m389 188.4-.7 3.9 165.8 23.8.8-4.3L389 188.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25303",
    d: "m373.1 186.5-147-20.7-.6 3.4 1 .1 145.9 21 .7-3.8z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25306_00000101793576541239303830000008849629238195805872_",
    d: "m286.4 251.9-3.8 21.5-66.2-14.6 15.1-86.4 67.2 9.8-9.6 53.8-2.7 15.9z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25307_00000059269266303991661380000000720626061164045480_",
    d: "m287.2 253.5-3.6 20.1 73 16 17-96.4-73.9-10.8-7.2 41-5.3 30.1z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25324_00000145042251742907768780000008982374353748548757_",
    d: "m454 286.1-4.3 24.3-74.8-16.4 17.1-97.5 75.9 11.1-10.9 60.7-3 17.8z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25325_00000141421813544698848900000007854561789873915306_",
    d: "m454.9 287.9-4 22.7 82.4 18 19.2-108.8-83.4-12.2-8.1 46.3-6.1 34z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_20_x25__00000085227712477789235390000013028878046445513109_",
    d: "m372.4 190.3 7.1-1.1.6-3.8-7 1.1zm182.4 21.5-.7 4.3 8-1.2.7-4.3zm-257.1-29.7 1 .1zm1 .1-9.6 53.9-2.7 15.8-3.8 21.5 1.2-1.2 3.4-18.7 5.4-30.1 7.2-41zm58 107.4 1.6-.9 17-96.2-1.6.6zM457 268.3l-3 17.8-4.3 24.3 1.4-1.3 3.8-21.2 6-34 8.2-46.2-1.3-.2zm9.7-61 1.1.2h.1zm66.6 121.3 1.9-.9 19.1-108.6-1.8.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_10_x25_",
    d: "m577.3 205.1-23.7 137 136.3-32 2.6-122.9-115.2 17.9z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_20_x25__00000167362145354110461790000008665790517488656825_",
    d: "m577.3 205.1 115.2-17.9v-5.9l-115.2 17.3v6.5z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_20_x25_",
    transform: "translate(2.849 6.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25289",
    d: "M280.9 290.5v126.8l4.7-1.2V291.6l-4.7-1.1z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25290",
    d: "M414.9 354.1v106.3l4.8-1.5v-137l-4.8-1.1v33.3",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25291",
    d: "M205 339.5v-66.2l-4.7-1.1v99.4l4.7-1v-31.1z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25292",
    d: "m225 148.2-4.3.4v5.1l-20.4 107.6 4.7-.7 18.6-98.1-1-.1.6-3.4 1-.1.8-4v-6.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25293",
    d: "M410.8 334.7h-.6c-.5-1.1-1.4-2-2.6-2.4-.4-.1-.8-.1-1.1 0l-.4.1-1.7.4c.3-.1.6-.1.9 0 1.9.4 3.4 2.9 3.4 5.6 0 2.1-1 3.7-2.3 4h.1l2.3-.5c1.5-.5 2.5-2 2.4-3.7h.2c.5-.1.8-.7.8-1.5-.1-.9-.6-1.7-1.4-2z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25294",
    d: "M277.9 303.2h-.5c-.4-1-1.3-1.8-2.3-2.1-.3-.1-.6-.1-.9 0l-.6.1-1.5.3h-.1c.3-.1.5-.1.8 0 2 .9 3.2 2.9 3 5 0 1.9-.9 3.3-2.1 3.6h.1l2.1-.5c1.3-.5 2.2-1.8 2.1-3.3l.2-.1c.5-.2.8-.8.7-1.3.2-.6-.3-1.4-1-1.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25295",
    d: "m225.4 395.8-13-16.1-4.9-6.1-2.2 5.3.5.7-.6.1c.2-.1.5-.1.7 0 1.8.8 2.9 2.6 2.7 4.5 0 1.7-.8 3-1.9 3.2l1.9-.4-.8 3.2 17.6 5.6z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25296",
    d: "m239.1 401.3 11 3.4-11.1 2.7.1-6.1z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25297",
    d: "m342.1 434.3.1 6.6 11.2-3.2-11.3-3.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_20_x25__00000120558621672501012260000015762310230508260283_",
    d: "m227.8 154.8.1 5.5 349.4 44.8v-6.4l-349.5-43.9z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlight_20_x25__00000021829631088613736360000012585966387657979305_",
    d: "m553.6 342.1 136.3-31.9.1-2.3 3.8 2.3 4 4.9L559 349.5l-5.2-4.3z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_10_x25__00000100362573996536907680000013907632694321979794_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_10_x25__00000039812459667184223350000001371405993806484891_",
    d: "M465.2 479.2v7.2l140.5-46.9v-6.6z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_10_x25__00000057106834001911170410000017437750241692324263_",
    d: "m559 349.5-5.7 10.5 144.2-36.6.3-8.3z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Highlight_30_x25__00000078016622707568043260000011843706272947674016_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25311",
    d: "m297.3 267.4-.2.9 5.4-1.1-2.1-.4-3.1.6z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25313",
    d: "m297.5 243.2 2.1.4 7.2-1.3-2.1-.4-7.2 1.3z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25314",
    d: "m273.6 238.6 2.1.4 7.1-1.3-2.1-.4-7.1 1.3z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25329",
    d: "m466.8 303.7-.2 1 6.1-1.2-2.4-.5-3.5.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25331",
    d: "m467.1 276.4 2.4.5 8.1-1.5-2.4-.5-8.1 1.5z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25332",
    d: "m440 271.1 2.4.5 8-1.5-2.3-.4-8.1 1.4z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Skugga_10_x25__00000074422430825455980060000006462591228581087363_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25310",
    d: "m306.9 242.3-.3 2.2-5.5 1-4 22.8 5.4-1.1-.4 2.2-7.1 1.4 4.7-27.2 7.2-1.3z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25315",
    d: "m282.4 239.7.3-1.9-7.1 1.3-4.8 26.7.6-.1-.6 3.8 1-.3.8-3.7 5.4-1.1.4-2.1-5.3 1.1 3.9-22.5 5.4-1.2z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25328",
    d: "m477.6 275.3-.3 2.5-6.2 1.2-4.5 25.8 6.1-1.2-.5 2.5-8 1.6 5.3-30.7 8.1-1.7z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_Locked_10m3_LDT10_svg__Path_25333",
    d: "m450 272.3.3-2.2-8 1.5-5.4 30.1.6-.1-.7 4.3 1.1-.3.9-4.2 6.1-1.3.4-2.4-6 1.2 4.4-25.4 6.3-1.2z",
    className: "Skip_Loader_Locked_10m3_LDT10_svg__st27"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipLoaderLocked10M3Ldt10);
export default __webpack_public_path__ + "static/media/Skip_Loader_Locked_10m3_LDT10.8c7fb7230c3c6922b0d61adf3ecb150e.svg";
export { ForwardRef as ReactComponent };